import React from 'react';
import {
  homepageElevatedPanelClassName,
  homepageSectionContainerClassName,
  homepageSectionPaddingYClassName,
  sectionHeadingAccentCenterClassName,
} from '../constants/homepageUi';

/** Differentiation vs generic marketplaces, raw crowdsourcing, and synthetic vendors. */
const PILLARS: { kicker: string; line: string }[] = [
  {
    kicker: 'Real-world capture',
    line: 'Homes, worksites, and everyday conditions—not renders, stock packs, or synthetic stand-ins.',
  },
  {
    kicker: 'Reviewed inputs',
    line: 'Expert review plus automated checks so batches land normalized and defensible before they hit your pipeline.',
  },
  {
    kicker: 'Purpose-built coverage',
    line: 'Scopes, tasks, and schemas aligned to the failure modes you ship against—not generic gig output.',
  },
  {
    kicker: 'Ready for your stack',
    line: 'COCO, YOLO, or internal formats. Structured for training, not a weekend re-labeling project.',
  },
];

const WhyPixanoSection: React.FC = () => {
  return (
    <section
      id="why-pixano"
      className={`scroll-mt-20 border-t border-[rgba(255,255,255,0.05)] bg-[#0B0F14] ${homepageSectionPaddingYClassName}`}
    >
      <div className={`${homepageSectionContainerClassName} flex flex-col items-center`}>
        <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">
          Why teams choose us
        </p>
        <h2
          className={`text-center text-3xl font-bold tracking-tight text-white sm:text-4xl ${sectionHeadingAccentCenterClassName} inline-block`}
        >
          Why Pixano
        </h2>
        <p className="mb-8 max-w-xl text-center text-sm leading-relaxed text-white/55 sm:mb-9 sm:text-[15px]">
          Built for buyers who can’t afford “close enough” data—when your model’s edge cases are the product.
        </p>

        <div className="mb-8 grid w-full max-w-[920px] grid-cols-1 gap-3 sm:mb-9 md:grid-cols-2 md:gap-4">
          {PILLARS.map((item) => (
            <div
              key={item.kicker}
              className={`${homepageElevatedPanelClassName} flex h-full flex-col p-5 transition-colors duration-200 sm:p-6 md:hover:border-[rgba(0,227,255,0.22)]`}
            >
              <p className="text-[15px] font-semibold tracking-tight text-white sm:text-base">{item.kicker}</p>
              <p className="mt-2.5 text-sm leading-relaxed text-white/60 sm:mt-3">{item.line}</p>
            </div>
          ))}
        </div>

        <p className="max-w-lg text-center text-[15px] font-medium leading-snug text-white/90 sm:text-base">
          We sell data the way we&apos;d want to buy it—documented, defensible, and ready to train.
        </p>
      </div>
    </section>
  );
};

export default WhyPixanoSection;
